const setSocketDisconnected = (state, payload) => {
  state.socketDisconnect = payload
}

const setSocketId = (state, payload) => {
  state.socketId = payload
}

const setHaveTriedToConnectWebsocket = (state, payload) => {
  state.haveTriedToConnectWebsocket = payload
}

const setWebsocketConnectionError = (state, payload) => {
  state.websocketConnectionError = payload
}

export default {
  setSocketDisconnected,
  setSocketId,
  setHaveTriedToConnectWebsocket,
  setWebsocketConnectionError,
}
